import { Component, ChangeDetectionStrategy, forwardRef, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { TitleInputLanguageType } from '../title-input-control/title-input-control.enum';
import { Subject, takeUntil, tap } from 'rxjs';

@Component({
  selector: 'osn-cxb-title-input-english-control',
  templateUrl: './title-input-english-control.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TitleInputEnglishControlComponent),
      multi: true,
    },
  ],
})
export class TitleInputEnglishControlComponent implements ControlValueAccessor, OnDestroy {
  public formControl = new FormControl<string>('');
  private readonly destroyed$ = new Subject<void>();
  public languageType = TitleInputLanguageType.ENGLISH;
  public label = 'Tray title English';

  constructor(private readonly changeDetectorRef: ChangeDetectorRef) {}

  public propagateChange: Function = () => {};
  public propagateTouch: Function = () => {};

  public writeValue(value: string): void {
    this.formControl.setValue(value);
    this.formControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        tap(() => this.changeDetectorRef.detectChanges())
      )
      .subscribe((inputValue) => {
        this.propagateChange(inputValue);
        if (this.propagateTouch) this.propagateTouch();
      });
    this.changeDetectorRef.detectChanges();
  }

  public registerOnChange(onChangeFunction: Function): void {
    this.propagateChange = onChangeFunction;
  }

  public registerOnTouched(onTouchFunction: Function): void {
    this.propagateTouch = onTouchFunction;
  }

  public ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
